"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createGenericReducer = void 0;
var tslib_1 = require("tslib");
var lodash_1 = require("lodash");
var omitBy_1 = tslib_1.__importDefault(require("lodash/omitBy"));
var isFirestoreFieldValue_1 = require("../../sdks/firebase/isFirestoreFieldValue");
var omitFieldValue = function (data) {
    return (0, omitBy_1.default)(data, function (field) {
        return (0, isFirestoreFieldValue_1.isFirestoreFieldValue)(field);
    });
};
var createGenericReducer = function (_a) {
    var getSuccessAction = _a.getSuccessAction, patchRequestAction = _a.patchRequestAction, deleteRequestAction = _a.deleteRequestAction, deleteSuccessAction = _a.deleteSuccessAction, postRequestAction = _a.postRequestAction, postFailureAction = _a.postFailureAction, _b = _a.clearActions, clearActions = _b === void 0 ? [] : _b, debug = _a.debug, extend = _a.extend;
    return function (state, action) {
        if (!action) {
            return state || null;
        }
        if (clearActions.indexOf(action.type) > -1) {
            return null;
        }
        switch (action.type) {
            case getSuccessAction: {
                if (debug) {
                    debugger;
                }
                var successAction = action;
                var newStateMutable_1 = Object.assign({}, state);
                (0, lodash_1.forEach)(successAction.successValues.items, function (value, id) {
                    newStateMutable_1[id] = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, newStateMutable_1[id]), value), { data: value.data });
                });
                return newStateMutable_1;
            }
            case postRequestAction: {
                if (debug) {
                    debugger;
                }
                var postApiRequestAction = action;
                var newStateMutable_2 = Object.assign({}, state);
                (0, lodash_1.forEach)(postApiRequestAction.requestValues.items, function (value, id) {
                    newStateMutable_2[id] = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, newStateMutable_2[id]), value), { data: value.data });
                });
                return newStateMutable_2;
            }
            case patchRequestAction: {
                if (debug) {
                    debugger;
                }
                var patchApiRequestAction = action;
                var newStateMutable_3 = Object.assign({}, state);
                (0, lodash_1.forEach)(patchApiRequestAction.requestValues.items, function (value, id) {
                    var _a;
                    if (newStateMutable_3[id]) {
                        // only update items that have already been loaded
                        newStateMutable_3[id] = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, newStateMutable_3[id]), value), { data: tslib_1.__assign(tslib_1.__assign({}, (_a = newStateMutable_3[id]) === null || _a === void 0 ? void 0 : _a.data), omitFieldValue(value.data)) });
                    }
                });
                return newStateMutable_3;
            }
            case deleteSuccessAction:
            case postFailureAction:
            case deleteRequestAction: {
                if (debug) {
                    debugger;
                }
                var deleteApiRequestAction = action;
                var deleteNewStateMutable_1 = Object.assign({}, state);
                (0, lodash_1.forEach)(deleteApiRequestAction.requestValues.items, function (_value, id) {
                    delete deleteNewStateMutable_1[id];
                });
                return deleteNewStateMutable_1;
            }
        }
        return extend ? extend(state, action) : state || null;
    };
};
exports.createGenericReducer = createGenericReducer;
